import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SettingsPageSkeleton } from './-components/skeleton'

export const Route = createFileRoute('/_authed/_user/settings')({
  component: SettingsLayout,
  pendingComponent: SettingsPageSkeleton,
  beforeLoad: () => ({
    getTitle: () => 'Settings',
  }),
})

function SettingsLayout() {
  return (
    <div className="space-y-6 pb-8 px-4 py-4 lg:px-6 md:py-6">
      <Outlet />
    </div>
  )
}
